import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { FamilyHistoryModel } from 'src/app/models/FamilyHistoryModel';
import { FamilyHistoryService } from 'src/app/services/FamilyHistoryService';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { MatDialog } from '@angular/material/dialog';
import { CanserModel } from 'src/app/models/CanserModel';
import { CanserService } from 'src/app/services/CanserService';

@Component({
  selector: 'app-family-history',
  templateUrl: './family-history.component.html',
  styleUrls: ['./family-history.component.css']
})
export class FamilyHistoryComponent implements OnInit {
////========== Family History ============================
    patientcode = '';
    Patientname = '';
    relativedegree = '' ;
    relation = '' ;
    cancerid = '' ;
    age = '' ;
    digdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    id =0;
  
  familyhistory :FamilyHistoryModel[] = [];
  cancerList: CanserModel[] =[];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public fhistory : FamilyHistoryModel,
              public fhistoryService : FamilyHistoryService,
              public canserService : CanserService,
              public storage: LocalStorageService,
              private dialogref: MatDialog,) { }

  ngOnInit(): void {
       this.patientcode = this.storage.retrieve('stgPatientCode');
        this.Patientname = this.storage.retrieve('stgPatientName');
        this.digdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
        this.retriveCancerLookup();
        this.retriveFHistory();
  }
  openDialog(){}
  retriveCancerLookup() {
    this.canserService.getCancerLookupTop()
      .subscribe((data: CanserModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.cancerList[i] = data[i];
        }
        //this.cancerName[] = [];
      });
  }

///////////========== Family History ===========////////
  retriveFHistory()
  {
    this.familyhistory = [];
    this.fhistoryService
      .getFamilyHistory(this.patientcode,this.storage.retrieve('stgcompCode'))
      .subscribe((data: FamilyHistoryModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.familyhistory[i] = data[i];

        }
        this.relativedegree = '' ;
        this.relation = '' ;
        this.cancerid = '' ;
        this.age = '' ;

      });
  }
  SelectFamily(fam: FamilyHistoryModel) {
    this.relation = fam.relation;
    this.cancerid = fam.cancerid;
    this.age = fam.age;
    this.id = fam.id;

    this.submitClicked.emit(this.fhistory);

  }
  submitFHistory() {
    if (this.patientcode == null || this.patientcode == '') {
      return;
    }
    this.fhistory.patientcode = this.patientcode;
    this.fhistory.relativedegree = this.relativedegree;
    this.fhistory.relation = this.relation;
    this.fhistory.cancerid = this.cancerid;
    this.fhistory.age = this.age;
    this.fhistory.userid = this.storage.retrieve('stguserId');
    this.fhistory.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
    this.fhistory.compcode = this.storage.retrieve('stgcompCode');

    this.fhistoryService.AddFamilyHistory(this.fhistory).subscribe(
      (data) => {


        this.relation = '' ;
        this.cancerid = '' ;
        this.age = '' ;

        this.retriveFHistory();
      },
      (error) => {
        alert(error);
      }
    );
}
  delFHistory_Line() {

  this.fhistoryService.delFamilyHistory(this.id.toString(),    this.storage.retrieve('stgcompCode') ) .subscribe((data: FamilyHistoryModel) => {

     this.relation = '' ;
      this.cancerid = '';
      this.age = '' ;
      this.retriveFHistory(); 
    });
      
  }
}
